import { StyleSheet } from 'react-native';

import { Box, BoxProps } from '@/components/lib/components';

type InnerBorderProps = {
    borderRadius: BoxProps['borderRadius'];
    borderColor: string;
    boxProps?: BoxProps;
};

export const InnerBorder = ({ borderRadius, borderColor, boxProps }: InnerBorderProps) => {
    return (
        <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            borderWidth={1}
            borderRadius={borderRadius}
            style={[styles.innerBorder, { borderColor }]}
            {...boxProps}
        />
    );
};

const styles = StyleSheet.create({
    innerBorder: {
        borderCurve: 'continuous',
    },
});
